/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { UserRoles } from '../../constants/user';
import { CurrentUserData, Permission } from '../../reducers/current-user';


export class PortfolioPermissions {

  static canManageRoles = [UserRoles.Owner, UserRoles.Manager];
  static canAccessInsightsAndDownloadsRoles = [
    UserRoles.Owner,
    UserRoles.Manager,
    UserRoles.Viewer,
  ];


  public static hasRoleToManage({ permissions }: Pick<CurrentUserData, 'permissions'>) {
    if (!permissions || permissions.length === 0) {
      return false;
    }
    return permissions.some(p => this.canManage(p))
  }

  public static canManage({ permissions }: Permission) {
    return permissions.some(role => this.canManageRoles.includes(role));
  }
}
